export default "__VITE_ASSET__b1305146__"